const errorCodes = {
  'Please login with your Telefono account': 10000,
  'The credentials entered are incorrect.': 10001,
  'There is already a user registered with this email.': 10002,
};

export const PeoopleError = (msg: string | keyof typeof errorCodes, errorCode: number = 500) => {
  const error = new Error(msg);
  // @ts-ignore
  error.statusCode = errorCodes[msg] || errorCode;
  return error as Error & {
    statusCode: number;
  };
};
